import {
  loaderReport,
  loaderSimpleGet,
} from "../../middleware/route-provider.js";
import EnergyTreePage from "./GVView/EnergyTree.js";
import GridTreePage from "./GVView/GridTree.js";
import GVViewIndexPage from "./GVView/index.js";
import MapPage from "./GVView/Map.js";
import SingleLineDiagramPage from "./GVView/SingleLineDiagram.js";
import GraphicalViewPage from "./index.js";

export default {
  path: "GV",
  children: [
    {
      path: "",
      element: <GraphicalViewPage />,
    },
    {
      path: "GVView",
      element: <GVViewIndexPage />,
    },
    {
      path: "GVView/Map",
      element: <MapPage />,
    },
    {
      path: "GVView/EnergyTree",
      element: <EnergyTreePage />,
    },
    {
      path: "GVView/GridTree",
      element: <GridTreePage />,
      loader: async () => {
        return await loaderSimpleGet({
          url: "GV/GridTree/GetData",
        });
      },
    },
    {
      path: "GVView/SingleLineDiagram",
      element: <SingleLineDiagramPage />,
      loader: async () => {
        return await loaderReport({
          url: "GV/SingleLineDiagram",
        });
      },
    },
  ],
};
